module.exports = __webpack_public_path__ + "img/268841164.5ff491c7.jpg";